module.exports = __webpack_public_path__ + "img/tree-02-d-leaves.17f04188.png";